var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/button-logic/templates/made-buttons.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perf")),"status") === "OnSale" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "series")),"status") !== "OnSale" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cyo")),"status") !== "OnSale") {
output += "\n    <!-- Perf on sale -->\n    <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"perfticketidUrl"), env.opts.autoescape);
output += "\" class=\"btn btn--buy-tickets\" data-auto-translate=\"true\">Buy Tickets</a>\n";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perf")),"status") !== "OnSale" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "series")),"status") === "OnSale" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cyo")),"status") !== "OnSale") {
output += "\n    <!-- Series on sale -->\n    <p data-auto-translate=\"true\">Get the best seats now by buying a package</p>\n    <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"seriesticketidUrl"), env.opts.autoescape);
output += "\" class=\"btn btn--buy-tickets\" data-auto-translate=\"true\">Buy Package</a>\n";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perf")),"status") !== "OnSale" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "series")),"status") !== "OnSale" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cyo")),"status") === "OnSale") {
output += "\n    <!-- CYO on sale -->\n    <p data-auto-translate=\"true\">Buy ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"tessituraCyoQuantity"), env.opts.autoescape);
output += " individual events and save</p>\n    <a data-perf-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"perfticketid"), env.opts.autoescape);
output += "\" data-perf-date=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perf")),"perfDate"), env.opts.autoescape);
output += "\" class=\"btn btn--cyo js-cyo-favorites-button\" data-auto-translate=\"true\">Create Your Own Package</a>\n";
;
}
else {
output += "\n    ";
if((lineno = 12, colno = 40, runtime.callWrap(runtime.memberLookup((["OnSale","FeedError"]),"indexOf"), "--expression--[\"indexOf\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perf")),"status")])) > -1) {
output += "\n        <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"perfticketidUrl"), env.opts.autoescape);
output += "\" class=\"btn buy-btn--with-dropdown btn--buy-tickets\" data-auto-translate=\"true\">Buy Now</a>\n    ";
;
}
output += "\n    <div class=\"dropdown ";
if((lineno = 15, colno = 61, runtime.callWrap(runtime.memberLookup((["OnSale","FeedError"]),"indexOf"), "--expression--[\"indexOf\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perf")),"status")])) > -1) {
output += "dropdown--with-buy-button ";
;
}
output += "\" data-js-view=\"dropdown\">\n        <button class=\"dropdown__btn dropdown__btn--next-to-btn\" data-js-ui=\"dropdown-trigger\" data-auto-translate=\"true\">Season Tickets &amp; Packages</button>\n        <div class=\"dropdown__content\" data-js-ui=\"dropdown-content\">\n            <button class=\"dropdown__close\" data-js-ui=\"dropdown-close\"></button>\n            <ul class=\"dropdown__list\">\n                ";
if((lineno = 20, colno = 53, runtime.callWrap(runtime.memberLookup((["OnSale","FeedError"]),"indexOf"), "--expression--[\"indexOf\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "series")),"status")])) > -1) {
output += "\n                    <li class=\"dropdown__item\">\n                        <p class=\"dropdown__item__text\" data-auto-translate=\"true\">Let us take you on an adventure, <br /><strong>buy a curated concert series</strong></p>\n                        <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"seriesticketidUrl"), env.opts.autoescape);
output += "\" class=\"dropdown__item__btn\" data-auto-translate=\"true\">See Season Tickets</a>\n                    </li>\n                ";
;
}
output += "\n                ";
if((lineno = 26, colno = 53, runtime.callWrap(runtime.memberLookup((["OnSale","FeedError"]),"indexOf"), "--expression--[\"indexOf\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cyo")),"status")])) > -1) {
output += "\n                    <li class=\"dropdown__item\">\n                        <p class=\"dropdown__item__text\" data-auto-translate=\"true\">Create your own adventure, <br /><strong>buy ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"tessituraCyoQuantity"), env.opts.autoescape);
output += " individual events and save</p>\n                        <a data-perf-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"perfticketid"), env.opts.autoescape);
output += "\" data-perf-date=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perf")),"perfDate"), env.opts.autoescape);
output += "\" class=\"dropdown__item__btn js-cyo-favorites-button\" data-auto-translate=\"true\">Create Your Own Package</a>\n                    </li>\n                ";
;
}
output += "\n            </ul>\n        </div>\n    </div>\n";
;
}
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/button-logic/templates/made-buttons.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/button-logic/templates/made-buttons.njk
// module id = 498
// module chunks = 0